import React, { useEffect, useState } from "react";
import MainHeader from "./MainHeader"

export default function MainHeaderCollapse() {
  const [small, setSmall] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () =>
        setSmall(window.pageYOffset > 200)
      );
    }
  }, []);

  return (
    <MainHeader className={`header ${
          small ? "small" : ""
        }`}>
      Logo etc.
    </MainHeader>
  );
}